module.exports = __webpack_public_path__ + "e1655d6267bf3afb38a06d5fc90dc47e.mp4";